var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneportLogoIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.48 167.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.04,33.39c-1.17-4.02-2.66-7.68-4.51-10.96-1.84-3.28-4.05-6.18-6.63-8.64-2.58-2.46-5.61-4.55-9.03-6.29-5.13-2.61-11.13-4.46-17.99-5.69-6.86-1.22-14.6-1.81-23.25-1.81h-20.78c-11.43,.01-21.28,1.06-29.64,3.3-4.18,1.12-7.98,2.54-11.41,4.31-3.42,1.76-6.46,3.87-9.06,6.35-2.59,2.47-4.82,5.38-6.69,8.67-2.8,4.93-4.8,10.68-6.11,17.22-1.31,6.53-1.94,13.86-1.94,22.02v55.82c0,10.91,1.11,20.34,3.48,28.37,1.19,4,2.7,7.66,4.57,10.95,1.87,3.28,4.1,6.19,6.7,8.66,.56,.53,1.15,1.05,1.76,1.55V84.18h13.28v-17.56c0-5.67,.16-10.47,.48-14.35,.3-3.86,.79-6.82,1.3-8.65,.55-1.95,1.26-3.61,2.12-5.03,.85-1.41,1.85-2.58,3.02-3.6,2.8-2.37,6.11-4.08,10.19-5.16,1.88-.49,4.87-.95,8.75-1.24,3.9-.3,8.71-.46,14.39-.46h10.17c5.73,0,10.57,.16,14.49,.45,3.91,.28,6.92,.73,8.81,1.21,4.08,1.04,7.34,2.7,10.04,4.98,1.17,1.02,2.16,2.19,3.02,3.6,.85,1.42,1.57,3.08,2.11,5.03,.52,1.83,1,4.79,1.31,8.65,.32,3.88,.48,8.68,.48,14.35v19.78h13.5v80.99c.58-.48,1.15-.98,1.69-1.49,2.61-2.47,4.85-5.38,6.73-8.66,2.82-4.93,4.82-10.69,6.14-17.24,1.32-6.55,1.95-13.9,1.95-22.09V61.87c0-10.98-1.1-20.45-3.44-28.48Zm-30.34,107.71c-.82,1.35-1.79,2.48-2.93,3.47-2.78,2.36-6.12,4.08-10.28,5.15-.44,.11-.93,.23-1.48,.33v17.9h15.81v-29.01c-.34,.78-.71,1.5-1.12,2.16Zm-36.49,10.33h-10.17c-1.07,0-2.11-.01-3.11-.02v16.54h15.81v-16.53c-.82,.01-1.67,.01-2.53,.01Zm-33.31-1.7c-4.08-1.08-7.39-2.79-10.19-5.16-1.18-1.02-2.18-2.2-3.03-3.59-.46-.75-.88-1.57-1.24-2.46v29.43h15.8v-17.92c-.5-.09-.94-.19-1.34-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.44,103.13h15.8v46.9c-.5-.09-.94-.19-1.34-.3-4.08-1.08-7.39-2.79-10.19-5.16-1.18-1.02-2.18-2.2-3.03-3.59-.46-.75-.88-1.57-1.24-2.46v-35.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.93,103.13h15.81v48.29c-.82,.01-1.67,.01-2.53,.01h-10.17c-1.07,0-2.11-.01-3.11-.02v-48.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.01,103.13h15.81v35.81c-.34,.78-.71,1.5-1.12,2.16-.82,1.35-1.79,2.48-2.93,3.47-2.78,2.36-6.12,4.08-10.28,5.15-.44,.11-.93,.23-1.48,.33v-46.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,66.07v20.11h-8.99V39.36H37.88v44.78h-8.83v-17.85c0-5.76,.16-10.64,.49-14.59,.3-3.92,.8-6.93,1.32-8.79,.56-1.98,1.28-3.67,2.15-5.11,.86-1.43,1.88-2.62,3.07-3.66,2.85-2.41,6.21-4.15,10.35-5.25,1.91-.5,4.95-.97,8.89-1.26,3.96-.3,8.85-.47,14.62-.47h10.33c5.82,0,10.74,.16,14.72,.46,3.97,.28,7.03,.74,8.95,1.23,4.15,1.06,7.46,2.74,10.2,5.06,1.19,1.04,2.19,2.23,3.07,3.66,.86,1.44,1.6,3.13,2.14,5.11,.53,1.86,1.02,4.87,1.33,8.79,.33,3.94,.49,8.82,.49,14.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.44,
    y: 103.13,
    width: 15.8,
    height: 64.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.93,
    y: 103.13,
    width: 15.81,
    height: 64.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.01,
    y: 103.13,
    width: 15.81,
    height: 64.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.44,
    y: 103.13,
    width: 15.8,
    height: 64.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.93,
    y: 103.13,
    width: 15.81,
    height: 64.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.01,
    y: 103.13,
    width: 15.81,
    height: 64.82
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneportLogoIconBlack);
export default __webpack_public_path__ + "static/media/oneport_logo_icon_black.8dd489c1e81a387b2c27b3533325bf67.svg";
export { ForwardRef as ReactComponent };